import { createSelector } from '@ngrx/store';
import { selectDashboardState } from '../dashboard.selectors';

export const selectMetricsState = createSelector(selectDashboardState, (dashboard) => dashboard?.metrics);

export const selectMetrics = createSelector(selectMetricsState, (metricsState) => ({
  modules: metricsState?.modules,
  partModIds: metricsState?.partModIds,
  participants: metricsState?.participants,
  interventionStructure: metricsState?.interventionStructure,
}));

export const selectFilter = createSelector(selectMetricsState, (metricsState) => ({
  filter: metricsState?.filter,
}));

export const selectIsLoadingMetrics = createSelector(
  selectMetricsState,
  (metricsState) => metricsState?.loadingMetrics
);

export const selectMetricsLoaded = createSelector(selectMetricsState, (metricsState) => metricsState?.metricsLoaded);

export const selectMetricsError = createSelector(selectMetricsState, (metricsState) => metricsState?.error);

export const selectUnanswered = createSelector(selectMetricsState, (metricsState) => metricsState?.unanswered);

export const selectIsDownloadingInterventionAnswers = createSelector(
  selectMetricsState,
  (metricsState) => metricsState?.downloadingInterventionAnswers
);

export const selectInterventionAnswersDownloaded = createSelector(
  selectMetricsState,
  (metricsState) => metricsState?.interventionAnswersDownloaded
);

export const selectIsInterventionAnswersTimingDownloading = createSelector(
  selectMetricsState,
  (metricsState) => metricsState?.downloadingInterventionAnswersTiming
);

export const selectInterventionAnswersTimingDownloaded = createSelector(
  selectMetricsState,
  (metricsState) => metricsState?.interventionAnswersTimingDownloaded
);
